<template>
  <transition name="fade" :duration="props.duration">
    <slot></slot>
  </transition>
</template>

<script lang="ts" setup>

import { defineProps } from 'vue';

const props = defineProps({
  duration: {
    type: Number,
    default: 800,
  },
});

</script>

<style scoped>
.fade-enter-active {
  transition: all ease-in-out;
}

.fade-leave-active {
  transition: all ease-in-out;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
